import React, { useEffect, Suspense, lazy } from 'react';
import { OrderBumpProvider } from './components/OrderBumpContext';
import { UrgencyBanner } from './components/UrgencyBanner';
import { HeroSection } from './components/HeroSection';
// Lazy load all below-the-fold sections
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const CreatorSection = lazy(() => import('./components/CreatorSection').then(m => ({
  default: m.CreatorSection
})));
const ForWhomSection = lazy(() => import('./components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BusinessSection = lazy(() => import('./components/BusinessSection').then(m => ({
  default: m.BusinessSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const OrderBumpSection = lazy(() => import('./components/OrderBumpSection').then(m => ({
  default: m.OrderBumpSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(m => ({
  default: m.FinalCTASection
})));
const PaymentPopup = lazy(() => import('./components/PaymentPopup').then(m => ({
  default: m.PaymentPopup
})));
function SectionFallback() {
  return <div className="w-full py-20" data-id="element-0" />;
}
export function App() {
  useEffect(() => {
    const load = () => import('./utils/hotmartTracking').then(m => m.initHotmartTracking('26904114352525543'));
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(load);
    } else {
      setTimeout(load, 1500);
    }
  }, []);
  return <OrderBumpProvider data-id="element-1">
      <div className="min-h-screen font-sans text-brand-brown bg-brand-cream selection:bg-brand-gold selection:text-white" data-id="element-2">
        <UrgencyBanner data-id="element-3" />
        <main data-id="element-4">
          <HeroSection data-id="element-5" />
          <Suspense fallback={<SectionFallback data-id="element-7" />} data-id="element-6">
            <PainSection data-id="element-8" />
          </Suspense>
          <Suspense fallback={<SectionFallback data-id="element-10" />} data-id="element-9">
            <SolutionSection data-id="element-11" />
          </Suspense>
          <Suspense fallback={<SectionFallback data-id="element-13" />} data-id="element-12">
            <CreatorSection data-id="element-14" />
          </Suspense>
          <Suspense fallback={<SectionFallback data-id="element-16" />} data-id="element-15">
            <ForWhomSection data-id="element-17" />
          </Suspense>
          <Suspense fallback={<SectionFallback data-id="element-19" />} data-id="element-18">
            <BusinessSection data-id="element-20" />
          </Suspense>
          <Suspense fallback={<SectionFallback data-id="element-22" />} data-id="element-21">
            <TestimonialsSection data-id="element-23" />
          </Suspense>
          <Suspense fallback={<SectionFallback data-id="element-25" />} data-id="element-24">
            <OfferSection data-id="element-26" />
          </Suspense>
          <Suspense fallback={<SectionFallback data-id="element-28" />} data-id="element-27">
            <OrderBumpSection data-id="element-29" />
          </Suspense>
          <Suspense fallback={<SectionFallback data-id="element-31" />} data-id="element-30">
            <GuaranteeSection data-id="element-32" />
          </Suspense>
          <Suspense fallback={<SectionFallback data-id="element-34" />} data-id="element-33">
            <FAQSection data-id="element-35" />
          </Suspense>
          <Suspense fallback={<SectionFallback data-id="element-37" />} data-id="element-36">
            <FinalCTASection data-id="element-38" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-39">
          <PaymentPopup data-id="element-40" />
        </Suspense>
      </div>
    </OrderBumpProvider>;
}